
import Vue, { VueConstructor } from 'vue';
import { email, maxLength } from 'vuelidate/lib/validators';
import InputValidationMixin from '@/mixins/Form/InputValidationMixin';

interface State {
  input: string,
}

export default (Vue as VueConstructor<Vue & InstanceType<typeof InputValidationMixin>>).extend({
  name: 'ContactEmailInput',
  mixins: [InputValidationMixin],
  props: {
    value: String,
  },
  data(): State {
    return {
      input: this.value,
    };
  },
  validations() {
    return {
      input: { email, maxLength: maxLength(100) },
    };
  },
  computed: {
    inputErrors(): Array<string> {
      const errors: Array<string> = [];

      if (!this.$v.input.$dirty) {
        return errors;
      }

      if (!this.$v.input.email) {
        errors.push('Need a proper email');
      }

      if (!this.$v.input.maxLength) {
        errors.push('Email must be below 100 characters!');
      }

      return errors;
    },
  },
  watch: {
    value(newValue) {
      this.input = newValue;
      this.$v.$reset();
    },
    input(newValue) {
      if (!newValue) {
        return;
      }

      this.$emit('input', newValue);
    },
  },
});
